import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TutorialService {
  private _isLandsPopoverVisible = new BehaviorSubject<boolean>(false);

  get isLandsPopoverVisible$() {
    return this._isLandsPopoverVisible.asObservable();
  }

  get isLandsPopoverVisible() {
    return this._isLandsPopoverVisible.value;
  }

  showLandsPopover() {
    this._isLandsPopoverVisible.next(true);
  }

  hideLandsPopover() {
    this._isLandsPopoverVisible.next(false);
  }
}
